<template>
	<!-- 导航栏 -->
	<div class="calendar-nav">
		<el-popover
			popper-class="calendar-year-dropdown"
			:visible-arrow="false"
			width="120"
			placement="bottom"
			trigger="click"
			v-model="visibleDropdown"
		>
			<el-scrollbar style="height: 100%">
				<div class="year-dropdown-content">
					<div
						v-for="year in years"
						:key="year"
						class="year-dropdown-item"
						:class="{ active: year === currentYear }"
						@click="changeYear(year)"
					>
						<span>{{ year }}</span>
						<SvgIcons v-show="year === currentYear" name="gouxuan" class="year-dropdown-icon" />
					</div>
				</div>
			</el-scrollbar>
			<div class="year-selector" slot="reference">
				<span class="year-text">{{ currentYear }}</span>
				<SvgIcons name="down" class="year-arrow" :class="visibleDropdown && 'rotate'" />
			</div>
		</el-popover>
		<div class="gap"></div>
		<div class="navigation-bar">
			<div class="nav-items">
				<button
					v-for="(nav, index) in navigationItems"
					:key="index"
					:class="['nav-item', { active: currentNavIndex === index }]"
					@click="handleNavClick(nav, index)"
				>
					{{ nav.label }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
// Props
defineProps({
	// 导航项数据
	navigationItems: {
		type: Array,
		default: () => []
		// 格式: [{ label: '1月', startIndex: 0, count: 5 }]
	},
	// 当前激活的导航索引
	currentNavIndex: {
		type: Number,
		default: 0
	}
});

const currentYear = ref(new Date().getFullYear());
const visibleDropdown = ref(false);

// 年份列表：始终以当前年份为基准，往前20年，往后1年
const years = computed(() => {
	const yearList = [];
	const todayYear = new Date().getFullYear();
	const startYear = todayYear - 20;
	const endYear = todayYear + 1;

	for (let year = startYear; year <= endYear; year++) {
		yearList.push(year);
	}

	return [...yearList].reverse();
});

const changeYear = year => {
	currentYear.value = year;
	visibleDropdown.value = false;
	// 抛出变化事件
	emit('changeYear', {
		year: currentYear.value
	});
};

// Emits
const emit = defineEmits(['nav-click']);

// 处理导航点击
const handleNavClick = (nav, index) => {
	emit('nav-click', { nav, index });
};
</script>

<style lang="less">
.calendar-year-dropdown {
	&.el-popper {
		margin-top: 0;
		padding: 0;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(0, 0, 0, 0.3);
		border-radius: 2px;
		height: 110px;
        background: var(--surf-secondary-color);
	}

	.year-dropdown-content {
		padding: 4px;

		.year-dropdown-item {
			padding: 0 12px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			color: rgba(var(--surf-inverse-color-rgb), 0.6);
			cursor: pointer;

			span {
				font-size: 14px;
			}
			.year-dropdown-icon {
				font-size: 16px;
				color: rgba(var(--surf-inverse-color-rgb), 1) !important;
			}

			&.active {
				color: rgba(var(--surf-inverse-color-rgb), 1);

				span {
					font-size: 16px;
				}
			}
		}
	}
	.el-scrollbar__wrap {
		overflow-x: hidden;
	}
}
</style>

<style lang="less" scoped>
.calendar-nav {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;

	.gap {
		width: 1px;
		height: 32px;
		background: rgba(var(--surf-inverse-color-rgb), 0.4);
		margin: 0 28px;
		flex-shrink: 0;
	}
	.year-selector {
		display: flex;
		align-items: center;
		cursor: pointer;
		gap: 8px;
		.year-text {
			color: rgba(var(--surf-inverse-color-rgb), 1);
			font-family: D-DIN;
			font-size: 40px;
			font-weight: 700;
			line-height: 48px; /* 120% */
		}
		.year-arrow {
			font-size: 16px;
			color: rgba(var(--surf-inverse-color-rgb), 1) !important;
			transition: transform 0.3s ease;
			&.rotate {
				transform: rotate(180deg);
			}
		}
	}
	.navigation-bar {
		position: sticky;
		top: 0;
		z-index: 10;
		padding: 12px 0;

		.nav-items {
			display: flex;
			gap: 20px;
		}

		.nav-item {
			padding: 5px 12px;
			border-radius: 4px;
			border: 0.5px solid rgba(var(--surf-inverse-color-rgb), 0.4);
			color: rgba(var(--surf-inverse-color-rgb), 1);
			font-size: 14px;
			font-weight: 400;
			line-height: 18px; /* 128.571% */
			cursor: pointer;
			white-space: nowrap;
			transition: all 0.2s;
            background: rgba(var(--surf-theme-color-rgb), 1);

			&.active{
				background: rgba(var(--surf-inverse-color-rgb), 1)!important;
				color: rgba(var(--surf-theme-color-rgb), 1);
				border-color: rgba(var(--surf-inverse-color-rgb), 1);
			}
			&:hover {
                background: rgba(var(--surf-inverse-color-rgb), 0.2)
			}
		}
	}
}
</style>
